module.exports = __webpack_public_path__ + "static/media/sumeet_barhona5.a7cda391.jpg";